// extracted by mini-css-extract-plugin
export default {"carouselControls":"ProjectCarousel_carouselControls__Joax5","slideCount":"ProjectCarousel_slideCount__FRjt8"};